import * as React from "react";
import PropTypes from "prop-types";

import MuiSwitch from "@mui/material/Switch";

function Switch(props) {
  return <MuiSwitch {...props} />;
}

export const SwitchPropTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

Switch.propTypes = SwitchPropTypes;

export default Switch;
